// 指定图表的配置项和数据
export // 指定图表的配置项和数据
var option = {

  backgroundColor: 'rgba(255, 255, 255, 0)',

  series: [{
    name: '全国',
    type: 'map',
    roam: true,
    hoverable: false,
    mapType: 'china',
    itemStyle: {
      normal: {
        borderColor: '#666a6d', // 边框颜色
        borderWidth: 2,
        areaStyle: {
          color: '#0a2e4e' // 地图块背景颜色
        }
      }
    },
    data: [],
    // 一些地理位置的坐标
    geoCoord: {
      // '上海': [121.4648, 31.2891],
      // '东莞': [113.8953, 22.901],
      // '东营': [118.7073, 37.5513],
      // '中山': [113.4229, 22.478],
      // '临汾': [111.4783, 36.1615],
    }
  }]

}
